var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRerunIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48822 8.24141C3.96257 3.38524 9.44726 0.96301 14.5901 2.18741C14.3881 1.66765 14.5944 1.06305 15.095 0.782958C15.6416 0.476912 16.3364 0.672109 16.6438 1.21898L17.9869 3.6128C18.2192 4.02907 18.1572 4.56751 17.8481 4.92045C17.7623 5.01838 17.6596 5.09077 17.5503 5.16105L15.1574 6.50361C14.6101 6.81056 13.9152 6.61486 13.6086 6.06841C13.4597 5.80341 13.4228 5.49608 13.5052 5.20321C13.5867 4.90952 13.7786 4.66745 14.0441 4.51834L14.1999 4.43085C10.0167 3.36097 5.5422 5.29819 3.51609 9.27466C1.16401 13.8909 3.00605 19.5601 7.62227 21.9122C12.2385 24.2643 17.9077 22.4222 20.2598 17.806C21.8441 14.6967 21.5811 10.9896 19.5729 8.13087C19.398 7.8813 19.3308 7.57862 19.3837 7.27867C19.4366 6.97905 19.6028 6.71834 19.8507 6.54594C20.3636 6.18595 21.0745 6.30988 21.4359 6.82325C23.9291 10.3729 24.2555 14.9772 22.2877 18.8393C19.3658 24.5736 12.3234 26.8619 6.58902 23.9401C0.854631 21.0182 -1.4336 13.9758 1.48822 8.24141Z",
    fill: "#6651BD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_552_2465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8335 13.5C9.8335 12.1607 9.8335 11.491 10.1183 11.1039C10.3667 10.7662 10.7485 10.5485 11.1688 10.5049C11.6507 10.4549 12.238 10.7897 13.4124 11.4594C14.5869 12.129 15.1742 12.4639 15.3712 12.901C15.5431 13.2823 15.5431 13.7177 15.3712 14.099C15.1742 14.5361 14.5869 14.871 13.4124 15.5406C12.238 16.2103 11.6507 16.5451 11.1688 16.4951C10.7485 16.4515 10.3667 16.2338 10.1183 15.8961C9.8335 15.509 9.8335 14.8393 9.8335 13.5Z",
    fill: "#6651BD",
    stroke: "#6651BD",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_552_2465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(8.5 9.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRerunIcon);
export default __webpack_public_path__ + "static/media/rerun-icon.5496893f939cb5bfddd1f0a006797b1a.svg";
export { ForwardRef as ReactComponent };